// removed by extract-text-webpack-plugin
module.exports = {"sectionList":"_1OJ21"};


/*****************
 ** WEBPACK FOOTER
 ** ./components/SectionList/styles.css
 ** module id = 347
 ** module chunks = 0
 **/